<div class="fx-row fx-v-center fx-gap-4 admin-context-breadcrumbs">
  <div class="dense-5 crumb">
    <!-- Landlord Autocomplete -->
    <mat-form-field appearance="fill" floatLabel="always" subscriptSizing="dynamic">
      <mat-label>Landlord</mat-label>
      <input matInput
             type="text"
             placeholder="Select a landlord"
             [formControl]="landlordCtrl"
             [matAutocomplete]="autoLandlords"
      >
      <button mat-icon-button matSuffix (click)="clearLandlords()" [hidden]="!landlordCtrl.value">
        <mat-icon class="admin-context-selector-autocomplete-icon">close_small</mat-icon>
      </button>
      <mat-autocomplete #autoLandlords="matAutocomplete" [displayWith]="displayFn"
                        (optionSelected)="onLandlordChange($event)">
        <mat-option *ngFor="let landlord of filteredLandlords | async" [value]="landlord">
          {{ landlord.name }}
        </mat-option>
        @if (!landlordCtrl.value) {
          <mat-option [value]="ADD_LANDLORD_SENTINEL">
            <mat-icon style="vertical-align: middle; font-size: 18px;">add</mat-icon>
            Add Landlord
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <span class="crumb-separator" aria-hidden="true">/</span>

  <div class="dense-5 crumb">
    <!-- Location Autocomplete -->
    <mat-form-field appearance="fill" floatLabel="always" subscriptSizing="dynamic">
      <mat-label>Location</mat-label>
      <input matInput
             type="text"
             placeholder="Select a location"
             [formControl]="locationCtrl"
             [matAutocomplete]="autoLocations"
             [readonly]="!selectedContext.landlord"
      >
      <button mat-icon-button matSuffix (click)="clearLocations()" [hidden]="!locationCtrl.value">
        <mat-icon class="admin-context-selector-autocomplete-icon">close_small</mat-icon>
      </button>
      <mat-autocomplete #autoLocations="matAutocomplete" [displayWith]="displayFn"
                        (optionSelected)="onLocationChange($event)">
        <mat-option *ngFor="let location of filteredLocations | async" [value]="location">
          {{ location.name }}
        </mat-option>
        @if (selectedContext.landlord && !locationCtrl.value) {
          <mat-option [value]="ADD_LOCATION_SENTINEL">
            <mat-icon style="vertical-align: middle; font-size: 18px;">add</mat-icon>
            Add Location
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <span class="crumb-separator" aria-hidden="true">/</span>

  <div class="dense-5 crumb">
    <!-- Offering Autocomplete -->
    <mat-form-field appearance="fill" floatLabel="always" subscriptSizing="dynamic">
      <mat-label>Offering</mat-label>
      <input type="text"
             matInput
             placeholder="Select an offering"
             [formControl]="offeringCtrl"
             [matAutocomplete]="autoOfferings"
             [readonly]="!selectedContext.location"
      >
      <button mat-icon-button matSuffix (click)="clearOfferings()" [hidden]="!offeringCtrl.value">
        <mat-icon class="admin-context-selector-autocomplete-icon">close_small</mat-icon>
      </button>
      <mat-autocomplete #autoOfferings="matAutocomplete" [displayWith]="displayFn"
                        (optionSelected)="onOfferingChange($event)">
        <mat-option *ngFor="let offering of filteredOfferings | async" [value]="offering">
          {{ offering.name }}
        </mat-option>
        @if (selectedContext.location && !offeringCtrl.value) {
          <mat-option [value]="ADD_OFFERING_SENTINEL">
            <mat-icon style="vertical-align: middle; font-size: 18px;">add</mat-icon>
            Add Offering
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>

  @if (loading$ | async) {
    <mat-spinner diameter="20" color="accent"></mat-spinner>
  } @else {
    <!-- Refresh Button -->
    <button mat-icon-button (click)="loadLandlords(true)">
      <mat-icon class="admin-context-selector-refresh-icon">refresh</mat-icon>
    </button>
  }

</div>
